<template>
  <!-- Course_Description Section 05 -->
  <div class="course_discription">
    <section class>
      <div class="container">
        <div class="container">
          <div class="">
            <div class="hero-textn">
              <h2>{{ Course.name }}</h2>
            </div>
           
          </div>
        </div>
      </div>
       <div class="hero-image">
              <img src="/assets/exported/course.jpg" alt />
            </div>
    </section>
    <section>
      <div class="container course_hero">
        <div class="container">
          <div class="text-center container" v-if="isLoading">
            <div class="spinnerdes">
              <div class="dot1"></div>
              <div class="dot2"></div>
            </div>
            <div class="shadow"></div>
          </div>
          <div class="course_d_list">
            <h2>{{ $root.course_des_p.text_des_p }}</h2>
            <div>
              <p>{{ Course.method }}</p>
            </div>
          </div>
          <div class="course_d_list">
            <h2>{{ $root.course_des_m.text_des_m }}</h2>
            <div>
              <p>{{ Course.purpose }}</p>
            </div>
          </div>
          <div class="course_d_list">
            <h2>{{ $root.course_des_c.text_des_c }}</h2>
            <div class="container">
              <div class>
                <div class="row_rg course_d">
                  <div class="column">
                    <div>
                      <b>
                        {{ $root.course_des_m_t.text_des_m_t }}
                        {{ Course.module_count
                        }}{{ $root.course_des_m_tt.text_des_m_tt }}
                      </b>
                    </div>
                  </div>
                  <div class="column_1" style="padding: 0px 0px 0px 5px;">
                    <div class="course_md_time_1">
                      <b>
                        {{ $root.course_des_t_t.text_des_t_t }}
                      </b>
                      <b v-if="Course.total_time.split(':')[0] != '০০'">
                        {{ Course.total_time.split(":")[0] }}
                        {{ $root.course_des_t_tt.text_des_t_tt }}
                      </b> 
                      <b>
                        {{ Course.total_time.split(":")[1] }}
                        {{ $root.course_des_t_m.text_des_t_m }}
                      </b>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="row_rg course_d course_md course_lm" style="padding:0px 0px">
                  <div class="course_modulas course_box_top">
                    <div
                      v-for="mod in Course.course_modules"
                      :key="mod.id"
                      class="column_1 course_list_body_mod_1"
                      style="list-style: none;"
                    >
                      <div class="uname table_box_shaw">
                        <span @click="toggleSelection(mod.id)" class="arrow_down">
                          <i
                            class="fa fa-sort-desc"
                            aria-hidden="true"
                            v-bind:class="{'color_active': mod.id == currentSelection && mod.sessions.length > 0}"
                          ></i>
                        </span>
                        <a
                          name="Modules_id mobile_width active"
                          @click="toggleSelection(mod.id)"
                          v-bind:class="{'color_active': mod.id == currentSelection && mod.sessions.length > 0}"
                        >
                          {{
                          mod.title
                          }}
                        </a>
                        <div class="course_md_time">
                          <a class="body_top">
                            {{ mod.minute }}
                            {{ $root.course_des_t_m.text_des_t_m }}
                          </a>
                        </div>
                        <ul class v-if="mod.sessions.length > 0 && currentSelection == mod.id">
                          <li
                            v-for="(session_v, s_index) in mod.sessions"
                            :key="s_index"
                            :value="session_v.id"
                            class="session_text"
                          >
                            <i class="fa fa-angle-right" aria-hidden="true" style="padding:0px 4px"></i>
                            {{ session_v.title }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="sub_reg login-section course_button light_button">
              <Slider />
            </div>
            <div class="sub_reg login-section course_button b_mobile">
              <button @click="DownloadClick(Course.id ,Course.download_file_url)" type="submit">
                <i class="fa fa-download" aria-hidden="true" style="margin-left:-5px;"></i>
                সম্পূর্ণ কোর্সটি ডাউনলোড করুন
              </button>
            </div>
            <div class="sub_reg login-section course_button b_mobile help_body">
             <button> <a href="/Adolescent_User_Manual_Web.pdf"
                        target="_blank">ব্যবহার  সহায়িকা </a></button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Slider from "../components/slider";
import axios from "axios";
//import Vue from 'vue'
export default {
  name: "",
  data() {
    return {
      Course: [],
      course_modules: [],
      sessions: [],
      currentSelection: -1,
      active_id: 0,
      showActive: false,
      isLoading: true,
    };
  },
  components: {
    Slider,
  },
  mounted() {
    if (this.$root.getSelectedCourse() == 0) {
      this.$router.push("/course_list");
    } else {
      this.reloadAPI();
      this.$root.page_hook = this;
    }
  },
  methods: {
    reloadAPI() {
      var course_id = this.$root.getSelectedCourse();

      // Get Data From Offline
      if (!navigator.onLine) {
        this.isLoading = false;
        if (
          window.localStorage.getItem("get-course-module-" + course_id) != null
        ) {
          console.log("Local Data: get-course-module-" + course_id);
          var localData = JSON.parse(
            window.localStorage.getItem("get-course-module-" + course_id)
          );
          this.Course = localData;
          return;
        }
      }

      var user_profile = JSON.parse(window.localStorage.getItem("profile"));
      var config = {
        headers: {
          "X-localization": this.$root.translate ? "bn" : "en",
          Authorization: "bearer " + user_profile.token,
        },
      };
      axios
        .get(
          this.$root.API_BASE_URL + "get-course-module?course_id=" + course_id,
          config
        )
        .then((response) => {
          // Response received From Server
          this.isLoading = false;

          console.log(response.data);
          if (response.data == []) {
            // Blank
            return;
          }

          // Save Locally
          localStorage.setItem(
            "get-course-module-" + course_id,
            JSON.stringify(response.data.data)
          );

          this.Course = response.data.data;
          console.log(this.Course.method);
        });
    },
    DownloadClick(d_id, link) {
      var fileLink = document.createElement("a");
      fileLink.target = "_blank";
      fileLink.href = link;
      fileLink.click();
      fileLink.setAttribute("download", link);
      document.body.appendChild(fileLink);
      document.body.removeChild(fileLink);
    },
    toggleSelection(id) {
      this.currentSelection = id;
      //this.showActive = !this.showActive;

      //if(this.showActive == false){
      //  this.currentSelection = -1;
      //}
    },
  },
  beforeMount() {
    this.$root.syncOnline();
  },
  beforeDestroy() {
    this.$root.page_hook = null;
  },
};
</script>

<style scoped>
.color_active {
  color: #005a06 !important;
}
.help_body button{
  background: #0000 !important;
  color: #005a06b8;
  text-decoration: underline;
}
.help_body a:hover,.help_body a{
  background: #0000 !important;
  color: #005a06b8;
  text-decoration: underline;
}
.active {
  color: #00b0ff;
}
.blue {
  color: #00b0ff;
  background-color: red;
}
.arrow_down {
  font-size: 22px;
  padding: 8px;
}
ul .session_text {
  width: 100%;
  height: auto;
  background-color: #fff;
  padding: 15px 20px 0px 20px;
  display: flex;
}
.table_box_shaw {
  background-color: #f9f9f9;
  margin-left: -20px;
  margin-bottom: 0px;
  height: auto;
  position: relative;
  margin-top: 10px;
}
.modules_id:active {
  color: #005a06;
}
.course_box_top {
  margin-top: -30px;
}
.course_modulas {
  padding: 20px 0px 0px 20px;
}
.course_md_time_1 {
  text-align: right;
  padding-right: 10px;
  margin-top: 0px;
}
.body_top {
  margin-top: 34px;
  padding-bottom: 0px;
  margin-bottom: 15px;
}
.light_button {
  background: transparent linear-gradient(267deg, #8fc15a 0%, #005a06 100%) 0%
    0% no-repeat padding-box;
  border-radius: 6px;
  opacity: 1;
  color: white;
  padding: 12px 20px;
  margin-bottom: 10px;
  margin-top: 10px;
  border: none;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}
@media screen and (max-width: 1200px) {
  .course_md_time_1 {
    padding-right: 0px;
    margin-right: -6px;
  }
  
}
@media screen and (max-width: 990px) {
  .course_md_time_1 {
    padding-right: 0px;
    margin-right: -14px;
  }
}
@media screen and (max-width: 768px) {
  .mobile_width {
    width: 80%;
  }
  .light_button {
    width: 88%;
  }
  .b_mobile {
    width: 88%;
  }
  .course_d a {
    width: 85%;
  }
  .course_md_time_1 {
    padding-right: 0px;
    margin-right: 4px;
  }
}
@media screen and (max-width: 480px) {
  .mobile_width {
    width: 80%;
  }
  .light_button {
    width: 90%;
  }
  .b_mobile {
    width: 90%;
  }
  .course_d a {
    width: 65%;
    display: inline-table;
  }
  .course_md_time_1 {
    padding-right: 0px;
    margin-right: -12px;
  }
}
@media screen and (max-width: 400px) {
  .mobile_width {
    width: 80%;
  }
  .light_button {
    width: 90%;
  }
  .b_mobile {
    width: 90%;
  }
  .course_d a {
    width: 65%;
    display: inline-table;
  }
  .course_md_time_1 {
    padding-right: 0px;
    margin-right: 4px;
  }
}
@media screen and (max-width: 330px) {
  .course_d b {
    font-size: 12px;
    padding-left: 0px;
  }
}
/* loading animation */
.text-center {
  z-index: 1012;
  max-width: 100vw;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow-x: scroll;
}
.shadow {
  background: #fff;
  z-index: 1011;
  width: 100%;
  height: 100%;
  opacity: 1;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
}
.spinnerdes {
  z-index: 1012;
  margin: 0;
  width: 40px;
  height: 40px;
  align-items: center;
  display: inline-block;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-animation: sk-rotate 2s infinite linear;
  animation: sk-rotate 2s infinite linear;
}
.dot1,
.dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #005a06;
  border-radius: 100%;

  -webkit-animation: sk-bounce 2s infinite ease-in-out;
  animation: sk-bounce 2s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0;
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes sk-rotate {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes sk-rotate {
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
@media (max-width: 683px) {
  .spinnerdes {
    align-items: center;
    display: inline-block;
    justify-content: center;
    position: absolute;
    left: 45%;
    top: 50%;
  }
}
</style>
